import { getLocaleDateString, getLocaleTimeString } from '@/utils'

import { createDebugPayloadErrorMessage } from '@/components/services/report-manager/commons/timeline/utils'

import render from './render'

export default {
  name: 'Items',

  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    items() {
      const payload = this.data?.debugPayload || []

      return payload.map(item => {
        const message = createDebugPayloadErrorMessage(item)
        const createdAt = [
          getLocaleDateString(item.createdAt),
          getLocaleTimeString(item.createdAt)
        ].filter(Boolean).join(' ')

        return {
          message,
          createdAt
        }
      })
    }
  },

  render
}
